<script>
export default {
    name: 'UserStatistics',
    props: {
        details: {
            type: Object,
            default: null,
        },
        isLoading: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        formatNumber(value) {
            return value?.toLocaleString('en-US') || '0';
        },
    },
    computed: {
        hasData() {
            return this.details !== null;
        },
        totalDownloads() {
            return this.formatNumber(this.details?.total_downloads);
        },
        zipDownloads() {
            return this.formatNumber(this.details?.images_downloaded_via_zip);
        },
        uniqueDownloads() {
            return this.formatNumber(this.details?.unique_downloaded_images);
        },
        totalCollections() {
            return this.formatNumber(this.details?.total_collections);
        },
    },
};
</script>

<template>
    <div class="statistics_content">
        <div v-if="isLoading" class="loading_state">Loading statistics...</div>
        <div v-else-if="!hasData" class="empty_state">
            No statistics available
        </div>
        <div v-else class="stats_grid">
            <div class="stat_card">
                <span class="stat_icon">📥</span>
                <span class="stat_value">{{ totalDownloads }}</span>
                <span class="stat_label">Full Image Path Requests</span>
            </div>
            <div class="stat_card">
                <span class="stat_icon">📦</span>
                <span class="stat_value">{{ zipDownloads }}</span>
                <span class="stat_label">ZIP File Path Requests</span>
            </div>
            <div class="stat_card">
                <span class="stat_icon">🎯</span>
                <span class="stat_value">{{ uniqueDownloads }}</span>
                <span class="stat_label">Unique Full Image Path Requests</span>
            </div>
            <div class="stat_card">
                <span class="stat_icon">📁</span>
                <span class="stat_value">{{ totalCollections }}</span>
                <span class="stat_label">Created Collections</span>
            </div>
        </div>
    </div>
</template>

<style scoped>
.statistics_content {
    padding: 5px 0 0 0;
}

.loading_state,
.empty_state {
    padding: 30px;
    text-align: center;
    color: var(--background-text, #ffffff);
    opacity: 0.7;
}

.stats_grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
    gap: 15px;
}

.stat_card {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 15px;
    background: rgba(0, 0, 0, 0.2);
    border-radius: 8px;
    text-align: center;
}

.stat_icon {
    font-size: 24px;
    margin-bottom: 8px;
}

.stat_value {
    font-size: 22px;
    font-weight: 700;
    color: var(--background-text, #ffffff);
}

.stat_label {
    font-size: 12px;
    color: var(--background-text, #ffffff);
    opacity: 0.7;
    margin-top: 4px;
}
</style>
